import { render, staticRenderFns } from "./modalPasswordExpiredSuccess.vue?vue&type=template&id=79c2c6ca&scoped=true"
import script from "./modalPasswordExpiredSuccess.vue?vue&type=script&lang=js"
export * from "./modalPasswordExpiredSuccess.vue?vue&type=script&lang=js"
import style0 from "./modalPasswordExpiredSuccess.vue?vue&type=style&index=0&id=79c2c6ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c2c6ca",
  null
  
)

export default component.exports